import type { QueryClient } from "@tanstack/react-query"

export function clearPrivateQueryCache(queryClient: QueryClient) {
  queryClient.removeQueries({ predicate: (query) => query.queryKey[0] !== "public-config" })
  queryClient.getMutationCache().clear()
}
